module.exports = __webpack_public_path__ + "assets/images/medic_g.c0684288.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/medic_g.png
// module id = 755
// module chunks = 1